export default __webpack_public_path__ + "static/tile-overview-light-496a7d80603fbad219fbc23890c94c06e6e646d5827f3aa12a810414232f0866.png";